const safetyChassisKeys = {
  all: ['SAFETY_CHASSIS'],
  listData: () => [...safetyChassisKeys.all, 'GET_LIST_DATA'],
  specificDataBase: () => [...safetyChassisKeys.all, 'GET_SPECIFIC_DATA'],
  specificData: ({ seq }) => [...safetyChassisKeys.specificDataBase(), seq],
};

export default safetyChassisKeys;
